/**
 * @ngdoc directive
 * @name charCount
 * @restrict A
 * @description
 * Detect the change of the charCount attribute and set the element html
 * with either the remaining or max characters. If the max is not provided,
 * it will be used 500 as default.
 *
 * Example:
 * <label
 *     char-count="{{textToCount}}"
 *     char-count-max="{{200}}"
 *     char-count-pre="Name"
 * </label>
 *
 * @memberof common
 * @return {Object} The directive properties.
 */
const CharCount = (errorHandler) => {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      charCount: '@',
      charCountMax: '@',
      charCountPre: '@',
    },
    link($scope, $element, attrs) {
      const defaultMaxCount = 500;
      let maxCount;
      try {
        maxCount = parseInt($scope.charCountMax, 10) || defaultMaxCount;
      } catch (error) {
        errorHandler.handleError(error);
        maxCount = defaultMaxCount;
      }

      const stopObserve = attrs.$observe('charCount', () => {
        const text = `${$scope.charCountPre} (`;
        if ($scope.charCount) {
          let remaining = maxCount - $scope.charCount.length;
          if (remaining < 0) {
            remaining = `<span class="charCountNegative">${remaining}</span>`;
          }

          $element.html(`${text}${remaining} characters remaining)`);
        } else {
          $element.html(`${text}${maxCount} characters max)`);
        }
      });

      $scope.$on('$destroy', () => {
        stopObserve();
      });
    },
  };
};

export default CharCount;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/directives/charCount.js